import React from 'react';
import type { HeadingNode } from '../types';

interface HeadingTreeProps {
  headings: HeadingNode[];
}

export const HeadingTree: React.FC<HeadingTreeProps> = ({ headings }) => {
  if (!headings.length) {
    return (
      <p className="meta" style={{ margin: 0 }}>
        No headings found. Every page should have at least one descriptive <code>&lt;h1&gt;</code>.
      </p>
    );
  }

  return (
    <div className="heading-tree">
      {headings.map((h, idx) => {
        const level = parseInt(h.tag.slice(1), 10);
        const indent = (level - 1) * 18;
        return (
          <div key={idx} className="heading-tree-row" style={{ paddingLeft: indent }}>
            <span className="heading-tree-tag">{h.tag.toUpperCase()}</span>
            <span className={`heading-tree-text${h.skipped ? ' is-skipped' : ''}`} title={h.skipped ? 'Heading level skipped' : undefined}>
              {h.text || <em style={{ color: 'var(--ink-4)' }}>(empty)</em>}
              {h.skipped && (
                <span className="pill pill-warning" style={{ marginLeft: 8, fontSize: 10 }}>
                  Skipped level
                </span>
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
};
